import React from "react";
import { useField, useFormikContext } from "formik";
import "./index.scss";

interface CheckboxGroupProps {
  type?: "checkbox" | "radio";
  label?: string;
  name: string;
  placeholder?: string;
  id?: string;
  mainDivClassName?: string;
  labelClassName?: string;
  optionClassName?: string;
  className?: string;
  error?: string;
  required?: boolean;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  customElement?: React.ReactNode;
  disabled?: boolean;
  options: { label: string; value: string | number; checked?: boolean }[];
}

const FormCheckboxGroup: React.FC<CheckboxGroupProps> = ({
  type = "checkbox",
  label,
  name,
  placeholder = "",
  id = "",
  mainDivClassName = "",
  labelClassName = "",
  optionClassName = "",
  className = "",
  required = false,
  handleChange,
  customElement,
  disabled = false,
  options = [],
  error,
}) => {
  const { values, setFieldValue } = useFormikContext<any>();
  const [field, meta] = useField(name);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, value } = event.target;
    const currentArray = values[name] || [];
    if (type === "checkbox") {
      if (checked) {
        setFieldValue(name, [...currentArray, value]);
      } else {
        setFieldValue(
          name,
          currentArray.filter((item: string) => item !== value)
        );
      }
    } else {
      setFieldValue(name, value);
    }

    if (handleChange) {
      handleChange(event);
    }
  };

  return (
    <div
      className={`${type === "checkbox" ? "checkbox-group" : "radio-group"} ${className} ${id}`}
    >
      {label && (
        <label className={labelClassName}>
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      {options?.map((option) => (
        <div key={option.value} className={`${type} ${mainDivClassName}`}>
          <input
            type={type}
            name={name}
            id={`${name}-${option.value}`}
            value={option.value}
            checked={
              String(field.value)?.includes(String(option.value)) ||
              String(field?.value?.value).includes(String(option.value))
            }
            onChange={onChange}
            placeholder={
              placeholder.charAt(0).toUpperCase() +
              placeholder.slice(1).toLowerCase()
            }
            disabled={disabled}
          />
          <label
            htmlFor={`${name}-${option.value}`}
            className={optionClassName}
          >
            {option.label}
          </label>
        </div>
      ))}
      {customElement}
      {(meta.touched && meta.error) ||
        (error && (
          <div className="text-danger error-message">{error || meta.error}</div>
        ))}
    </div>
  );
};

export default FormCheckboxGroup;
